import {Inject, Injectable} from '@angular/core';
import { CrudService } from 'src/app/core/services/crud.service';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { IApiKey } from './models/api-key.model';
import { ApiSentrynelService } from 'src/app/core/services/api-sentrynel.service';
import { APIKEY_QUERY_SERVICE_INSTANCE } from './amministrazione.config';
import { UserDeleghe } from './models/user.model';

const CRUD_ENDPOINT = 'auth';
@Injectable({
  providedIn: 'root'
})
export class AmministrazioneService extends CrudService<IApiKey> {

  constructor(
    @Inject(APIKEY_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<IApiKey>,
    @Inject(ApiSentrynelService) protected  readonly apiSentrynel: ApiSentrynelService,
    @Inject(ApiService) protected  override readonly api: ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(CRUD_ENDPOINT,api, snackbar);
  }

  get() {
    return this.apiSentrynel.get<IApiKey>(`${CRUD_ENDPOINT}/client-info`);
  }

  getClient(){
    return this.apiSentrynel.get<IApiKey>(`${CRUD_ENDPOINT}/client-info`);
  }
  createClient(){
    return this.apiSentrynel.post<IApiKey>(`${CRUD_ENDPOINT}/client-create`, {});
  }
  deleteClient(){
    return this.apiSentrynel.post<IApiKey>(`${CRUD_ENDPOINT}/client-delete`, {});
  }

  getDeleghe(id:number, updateId:number) {
    return this.api.get<UserDeleghe[]>(`get-user?id=${id}&updateBy=${updateId}`);
  }
  setDelegheRoles(data:UserDeleghe) {
    return this.api.post<any[]>(`update-user`, data);
  }
}
